import './gallery.css';
export default {
  "gallery": "pf-v6-l-gallery",
  "modifiers": {
    "gutter": "pf-m-gutter"
  }
};